import React from 'react';
import PropTypes from 'prop-types';
import { FaSortDown, FaSortUp } from 'react-icons/fa';

const UpDownIcon = props => (props.isUp ? <FaSortUp /> : <FaSortDown />);

UpDownIcon.propTypes = {
  isUp: PropTypes.bool,
};

UpDownIcon.defaultProps = {
  isUp: false,
};
export default UpDownIcon;
